import { FormatAlignCenter, FormatAlignLeft, FormatAlignRight } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import { Editor } from "@tiptap/react";
import { useEffect, useState } from "react";

interface NoteTextAlignProps {
    editor: Editor;
    mode: number;
}

export default function NoteTextAlign({ editor, mode }: NoteTextAlignProps) {
    const [activeAlign, setActiveAlign] = useState<'left' | 'center' | 'right' | null>(null);
  
    useEffect(() => {
      const updateActiveAlign = () => {
        if (editor.isActive({ textAlign: 'left' })) setActiveAlign('left');
        else if (editor.isActive({ textAlign: 'center' })) setActiveAlign('center');
        else if (editor.isActive({ textAlign: 'right' })) setActiveAlign('right');
        else setActiveAlign(null);
      };

      editor.on('selectionUpdate', updateActiveAlign);
  
      return () => {
        editor.off('selectionUpdate', updateActiveAlign);
      };
    }, [editor]);
  
    const toggleAlign = (align: 'left' | 'center' | 'right') => {
      if (activeAlign === align) {
        editor.chain().focus().unsetTextAlign().run();
        setActiveAlign(null);
      } else {
        editor.chain().focus().toggleTextAlign(align).run();
        setActiveAlign(align);
      }
    };
  
    const getButtonStyles = (align: 'left' | 'center' | 'right') => ({
      backgroundColor: activeAlign === align ? '#e8f0fe' : 'transparent',
      color: activeAlign === align ? (mode === 1 ? '#1a73e8' : 'white') : (mode === 1 ? 'inherit' : 'white'),
    });
  
    return (
      <>
        <Tooltip title="Align left">
          <IconButton size="small" onClick={() => toggleAlign('left')} sx={getButtonStyles('left')}>
            <FormatAlignLeft sx={{ fontSize: 18 }} />
          </IconButton>
        </Tooltip>
  
        <Tooltip title="Align center">
          <IconButton size="small" onClick={() => toggleAlign('center')} sx={getButtonStyles('center')}>
            <FormatAlignCenter sx={{ fontSize: 18 }} />
          </IconButton>
        </Tooltip>
  
        <Tooltip title="Align right">
          <IconButton size="small" onClick={() => toggleAlign('right')} sx={getButtonStyles('right')}>
            <FormatAlignRight sx={{ fontSize: 18 }} />
          </IconButton>
        </Tooltip>
      </>
    );
  }
  
